import ContentBody from 'components/content-body/content-body';
import ContentContainer from 'components/content-container/content-container';
import ContentHeaderTitle from 'components/content-header-title/content-header-title';
import ContentHeader from 'components/content-header/content-header';
import Content from 'components/content/content';
import React, { FunctionComponent } from 'react';
import { ExportSepaSearchInvoicesForm } from './export-sepa-search-invoices-form.container';

export const ExportSepaPage: FunctionComponent = () => {
  return (
    <Content>
      <ContentHeader>
        <ContentHeaderTitle>Export SEPA</ContentHeaderTitle>
      </ContentHeader>
      <ContentBody>
        <ContentContainer>
          <ExportSepaSearchInvoicesForm />
        </ContentContainer>
      </ContentBody>
    </Content>
  );
};
